<div class="mdl-grid mdl-grid--no-spacing">
  <h5 class="mdl-layout-title mdl-cell--12-col">
    {{'DEFAULT_LOGOS' | translate}}
  </h5>
  <div class="mdl-cell--12-col">
    <md-card>
      <md-card-content>

        <adm-document-view
          base-url-upload="ctrl.baseUrlUpload"
          controller-url-upload="ctrl.controllerUrlUpload"
          id-entitat="ctrl.idEntitat"
          list-documents="ctrl.logos"
          show-edit="$root.permisos.LOGO.edit"
          edit-function="ctrl.makeLogoPred"
          upload-end-function="ctrl.uploadEndFunction">
        </adm-document-view>

      </md-card-content>
    </md-card>
  </div>
</div>
